export const hoverLink = "hover:text-secondary cursor-pointer";
